import './App.css';
import React from 'react';
import FullPage from '../components/FullPage.js'

class App extends React.Component {

  render() {
    return (
      <div className="tc">
        <FullPage/>
      </div>
    )
  }
}
export default App;
